import { AUTOSHIP_ONE_TIME_OPTION, getAutoshipFrequencyOptions } from '@libs/common-types';

/*
 * If the user is logged in, we need to add a one-time option to the frequency drop down
 */
export const getFrequencyOptions = (userHasSubscriptions = false, as_freq_5_7 = false) => {
    const frequencyOptions = getAutoshipFrequencyOptions(as_freq_5_7);

    if (!userHasSubscriptions) {
        return frequencyOptions;
    }

    return [AUTOSHIP_ONE_TIME_OPTION, ...frequencyOptions];
};
